<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-icon class="mb-3" color="blue-grey lighten-1" size="32"
      >mdi-ghost-outline</v-icon
    >
    <p
      class="ma-0 pa-0 blue-grey--text text--darken-1 subtitle-2 mb-1 text-center"
    >
      {{ $t('excel.no_results_found') }}
    </p>
    <p class="ma-0 pa-6 blue-grey--text caption mb-3 text-center">
      {{ $t('common.empty_state_message') }}
    </p>
    <v-btn
      v-if="action"
      rounded
      plain
      text
      color="blue"
      @click="$emit('click')"
      >{{ action }}</v-btn
    >
  </div>
</template>

<script>
export default {
  name: 'EmptyResults',

  props: {
    action: { required: false, type: String },
  },
}
</script>
